skyward.base.registerScript("statereportingwa", function (skyward, $)
{
    "use strict";
        
    var displayStudentEntityFTEWACalculationPopup = function ()
    {
        var button = $(this);
        var studentid = button.data().studentid;
        var entityid = button.data().entityid;
        var schoolyearid = button.data().schoolyearid;

        var buildPopup = function () {
            return $.ajax({
                url: skyward.global.virtualDir + "Enrollment/StudentEntityFTEWA/DisplayStudentEntityFTEWACalculation",
                type: "POST",
                dataType: "viewparthtml",
                data: { studentid: JSON.stringify(studentid), entityid: JSON.stringify(entityid), schoolYearid: JSON.stringify(schoolyearid) }
            });
        };

        var popupTitle = "Calculated FTE";
        skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button });
    };

    /**
     * Handle the event that the StatePlacementTestWAID code EEL control has
     * been loaded on an EnglishLearnerWA form.
     * @param {any} statePlacementTestWAIDDiv The .codeEEL <div> element jQuery
     * object for the StatePlacementTestWAID control.
     */
    function handleStatePlacementTestWAIDLoad(statePlacementTestWAIDDiv)
    {
        let formContainer = statePlacementTestWAIDDiv.closest(".dataObjectViewer");
        let prefix = "";
        if (!formContainer.length)
        {
            formContainer = statePlacementTestWAIDDiv.closest(".workflowContent");
            prefix = "EnglishLearnerWA.";
        }

        const statePlacementTestWAIDWIDAScreener = skyward.controls.getValue(formContainer.find("[name='StatePlacementTestWAIDWIDAScreener']"));

        if (!formContainer || !statePlacementTestWAIDWIDAScreener)
        {
            return;
        }

        const placementTestScoreInput = formContainer.find(`[name='${prefix}PlacementTestScore']`);
        const stateOverallPlacementTestScoreWAIDFieldSet = formContainer.find(`[name='${prefix}StateOverallPlacementTestScoreWAID']`).closest("fieldset");
        const stateOverallPlacementTestScoreWAIDDiv = stateOverallPlacementTestScoreWAIDFieldSet.find(".codeEEL");

        const widaScreenerDomains =
        [
            {
                name: "Listening",
                placeValue: 1000
            },
            {
                name: "Reading",
                placeValue: 100
            },
            {
                name: "Speaking",
                placeValue: 10
            },
            {
                name: "Writing",
                placeValue: 1
            }
        ];

        for (const widaScreenerDomain of widaScreenerDomains)
        {
            widaScreenerDomain.fieldSet = formContainer.find(`[name='${prefix}StateWIDAScoreWAID${widaScreenerDomain.name}']`).closest("fieldset");
            widaScreenerDomain.div = widaScreenerDomain.fieldSet.find(".codeEEL");
            widaScreenerDomain.codeInput = widaScreenerDomain.div.find(".codeEELCode");

            widaScreenerDomain.div.on("eelComplete", handleStateWIDAScoreWAIDEELComplete);
        }

        statePlacementTestWAIDDiv.on("eelComplete", handleStatePlacementTestWAIDEELComplete);

        /**
         * Handle the event that the StatePlacementTestWAID code EEL control has
         * been set. This will show/hide/clear any controls that display only when
         * StatePlacementTestWAID is '10 - WIDA Screener'.
         */
        function handleStatePlacementTestWAIDEELComplete()
        {
            // When StatePlacementTestWAID is changed to '10 - WIDA Screener'.
            if (skyward.controls.getValue(statePlacementTestWAIDDiv) === statePlacementTestWAIDWIDAScreener)
            {
                skyward.controls.disable(placementTestScoreInput);

                // Pad the displayed value with zeroes to make it four digits long.
                const currentPlacementTestScore = Number.parseInt(skyward.controls.getValue(placementTestScoreInput));
                if (!Number.isNaN(currentPlacementTestScore))
                {
                    skyward.controls.setValue(placementTestScoreInput, padNumberToFourDigits(currentPlacementTestScore))
                }

                for (const widaScreenerDomain of widaScreenerDomains)
                {
                    skyward.controls.show(widaScreenerDomain.fieldSet);
                }

                skyward.controls.show(stateOverallPlacementTestScoreWAIDFieldSet);
            }
            // When StatePlacementTestWAID is changed to something other than '10 - WIDA Screener'.
            else
            {
                skyward.controls.enable(placementTestScoreInput);

                // Remove any padded zeroes from the displayed value.
                const currentPlacementTestScore = Number.parseInt(skyward.controls.getValue(placementTestScoreInput));
                if (!Number.isNaN(currentPlacementTestScore))
                {
                    skyward.controls.setValue(placementTestScoreInput, currentPlacementTestScore)
                }

                for (const widaScreenerDomain of widaScreenerDomains)
                {
                    if (skyward.controls.getValue(widaScreenerDomain.div))
                    {
                        skyward.codeeel.clear(widaScreenerDomain.div, true);
                    }
                    skyward.controls.hide(widaScreenerDomain.fieldSet);
                }

                skyward.codeeel.clear(stateOverallPlacementTestScoreWAIDDiv, true);
                skyward.controls.hide(stateOverallPlacementTestScoreWAIDFieldSet);
            }
        }

        /**
         * Handle the event that one of the four StateWIDAScoreWAID code EEL controls
         * has been set. If all the WIDA score EELs have a value selected, this will
         * update the value of the PlacementTestScore control accordingly.
         */
        function handleStateWIDAScoreWAIDEELComplete()
        {
            let newPlacementTestScoreValue = 0;
            for (const widaScreenerDomain of widaScreenerDomains)
            {
                const numericDomainValue = Number.parseInt(skyward.controls.getValue(widaScreenerDomain.codeInput), 10);
                if (typeof numericDomainValue !== 'number' || Number.isNaN(numericDomainValue))
                {
                    // If any of the WIDA score code <input>s is empty, don't update PlacementTestScore.
                    return;
                }

                newPlacementTestScoreValue += numericDomainValue * widaScreenerDomain.placeValue;
            }

            skyward.controls.setValue(placementTestScoreInput, padNumberToFourDigits(newPlacementTestScoreValue));
        }

        function padNumberToFourDigits(number)
        {
            return number.toString().padStart(4, '0');
        }
    }

    function onIsSubstituteInstructionalStaffLoaded(topIsSubstituteInstructionalStaffCheckbox)
    {
        $(document).on('browseLoaded.TempSubstituteAssignments', function ()
        {
            $('#TempSubstituteAssignments input[id^="IsInstructionalStaff-"]').each(function (i, browseCheckbox)
            {
                const jQueryBrowseCheckbox = $(browseCheckbox);

                if (!jQueryBrowseCheckbox.data().hasStateReportingWAChangeEventHandler)
                {
                    jQueryBrowseCheckbox.data('hasStateReportingWAChangeEventHandler', 'true');

                    jQueryBrowseCheckbox.on('change', function ()
                    {
                        var parts = browseCheckbox.id.split('-');

                        if (parts.length > 0)
                        {
                            var stateTeacherIndicatorCodeEel = $('#StateTeacherIndicatorWAID-' + parts[1]);
                            var stateTeacherIndicatorCodeEelValue = $('#StateTeacherIndicatorWAID-' + parts[1] + '_value');
                            if (!browseCheckbox.checked)
                            {
                                skyward.controls.clearValue(stateTeacherIndicatorCodeEel);
                                skyward.controls.disable(stateTeacherIndicatorCodeEelValue);
                            }
                            else if (browseCheckbox.checked)
                            {
                                skyward.controls.enable(stateTeacherIndicatorCodeEelValue);
                            }
                        }
                    })
                }
            })
        })
    }

    // Event handlers
    var events =
    {
        "displayStudentEntityFTEWACalculationPopup": displayStudentEntityFTEWACalculationPopup,
        "handleStatePlacementTestWAIDLoad": handleStatePlacementTestWAIDLoad,
        "onIsSubstituteInstructionalStaffLoaded": onIsSubstituteInstructionalStaffLoaded
    };

    return events;
});